import { memo, useContext } from "react";
import { TOContext } from "context/TContext";
import { THeaderTitle } from "components/styles";


const TOCardHeader = () => {
  const { business } = useContext(TOContext);
  return (
    <THeaderTitle>{business?.title || business?.companyName}</THeaderTitle>
  )
}

export default memo(TOCardHeader)